import React from 'react';
import {connect} from 'react-redux';

class RatingFilter extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`bar w-100 p-2 bg-white border-bottom shadow-sm filter-bar-wrapper d-flex ${this.props.middleCenter ? 'align-items-center' : ''}`}>
                {this.props.children}
            </div>
        );

    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(RatingFilter);
